import { FC } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useMutation } from "react-query";
import api from "api";
import { CgSpinnerAlt } from "react-icons/cg";
import { useNavigate } from "react-router-dom";

interface LoginFormValues {
	username: string;
	password: string;
}

const Login: FC = () => {
	const navigate = useNavigate();
	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm<LoginFormValues>({
		resolver: yupResolver(
			yup.object({
				username: yup.string().required("Username is required"),
				password: yup.string().required("Password is required"),
			})
		),
	});

	const { isLoading, mutate: login } = useMutation((data: LoginFormValues) => api.auth.login(data), {
		onSuccess: () => navigate("/"),
	});

	return (
		<div className="w-screen h-screen bg-black flex items-center justify-center">
			<form
				onSubmit={handleSubmit((data) => login(data))}
				className="border-2 border-gray-primary flex flex-col items-center space-y-2 p-5 rounded-lg"
			>
				<div className="text-primary text-2xl font-medium mb-5">Genius Orders</div>
				<div className="pb-1 relative">
					<div className="relative">
						<input
							{...register("username")}
							className="outline-none border-gray-primary border-2 placeholder:text-gray-primary bg-black rounded py-1.5 focus:outline-primary w-72 mb-1 text-center tracking-widest placeholder:tracking-normal"
							placeholder="Username"
						/>
					</div>
					{errors.username && <div className="text-center text-red-400 text-sm">{errors.username.message}</div>}
				</div>
				<div className="pb-5">
					<input
						type="password"
						{...register("password")}
						className="outline-none border-gray-primary border-2 placeholder:text-gray-primary bg-black rounded px-3 py-1.5 text-center focus:outline-primary w-72 mb-1"
						placeholder="Password"
					/>
					{errors.password && <div className="text-center text-red-400 text-sm">{errors.password.message}</div>}
				</div>
				<button
					type="submit"
					className="bg-primary text-white w-full py-1.5 rounded font-medium text-sm flex justify-center"
					disabled={isLoading}
				>
					{isLoading ? <CgSpinnerAlt className="text-white animate-spin w-5 h-5" /> : "Login"}
				</button>
			</form>
		</div>
	);
};

export default Login;
